<template>
  <div class="container mt-5">
    <h2>{{ grupoId ? "Editar Grupo de Cumplimiento" : "Alta de Grupo de Cumplimiento" }}</h2>

    <div class="section mb-4">
      <h4>Datos del Grupo</h4>

      <div class="mb-3">
        <label for="groupName" class="form-label">Nombre del Grupo</label>
        <input
          type="text"
          class="form-control"
          id="groupName"
          v-model="grupo.nombre"
          required
        />
      </div>

      <div class="mb-3">
        <label for="groupDescription" class="form-label">Descripción del Grupo</label>
        <textarea
          class="form-control"
          id="groupDescription"
          v-model="grupo.descripcion"
        ></textarea>
      </div>

      <div class="mb-3">
        <label for="groupColor" class="form-label">Color del Grupo</label>
        <input
          type="color"
          class="form-control form-control-color"
          id="groupColor"
          v-model="grupo.color"
          @input="validateColor"
        />

      </div>

      <button class="btn btn-primary" @click="guardarGrupo">
        {{ grupoId ? "Actualizar Grupo" : "Guardar Grupo" }}
      </button>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  props: {
    grupoId: {
      type: [Number, String], // Permitir tanto String como Number
      default: null,
      coerce: value => Number(value), // Convertir a número si es necesario
    },

  },
  data() {
    return {
      grupo: {
        nombre: "",
        descripcion: "",
        color: "#000000",
      },
      clubActual: null,
    };
  },
  
  methods: {
    async guardarGrupo() {
      try {

        //validar que el color no esté en el rango de 0 a 9 y de A a F
        if(!this.isValidColor(this.grupo.color)){
          alert("Por favor, elige un color más oscuro.");
          this.grupo.color = "#000000"; // Restablecer a color válido
          return;
        }


        if (this.grupoId) {
          await axios.put(
            `/api/cumplimiento/grupos/${this.grupoId}`,
            {form:this.grupo, club_id: this.clubActual.id}
          );
          alert("Grupo actualizado correctamente.");
        } else {
          await axios.post(
            "/api/cumplimiento/grupos",
            {form:this.grupo, club_id: this.clubActual.id}
          );
          alert("Grupo creado correctamente.");
        }
        this.$emit('grupoGuardado', this.grupo); // Emitir evento con el grupo
      } catch (error) {
        console.error("Error al guardar el grupo:", error);
      }
    },
    async cargarGrupo() {
      if (this.grupoId) {
        try {
          const response = await axios.get(
            `/api/cumplimiento/grupos/${this.grupoId}`,{params: {club_id: this.clubActual.id}}
          );
          this.grupo = response.data;
        } catch (error) {
          console.error("Error al cargar grupo:", error);
        }
      }
    },
    validateColor() {
        const colorRegex = /^#([0-9A-F]{6})$/i;
        if (!colorRegex.test(this.grupo.color)) {
          this.grupo.color = "#000000"; // Restablecer a color válido
          alert("El color no tiene un formato válido. Se ha restablecido al valor predeterminado.");
        }
      },
      isValidColor(color) {
          const colorRegex = /^#([0-9A-F]{6})$/i;
          if (!colorRegex.test(color)) {
            return false; // No es un formato válido de color
          }

          // Extraer valores RGB
          const r = parseInt(color.slice(1, 3), 16);
          const g = parseInt(color.slice(3, 5), 16);
          const b = parseInt(color.slice(5, 7), 16);

          // Calcular brillo relativo (https://www.w3.org/TR/AERT/#color-contrast)
          const brightness = (0.299 * r + 0.587 * g + 0.114 * b);
          
          // Retornar false si el brillo es alto (evitar colores claros)
          return brightness < 200; // Ajusta este valor para definir qué tan claro es aceptable
        },
  },
  mounted() {
    this.clubActual = this.$store.getters.getClubActual;
    this.cargarGrupo();
  },
};
</script>

<style scoped>
.section {
  border: 1px solid #e3e3e3;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}
</style>
